import React, { useEffect } from 'react';
import RedesContacto from './RedesContacto';
export default function VulneracionVssexual({ 
	register, 
    watch, 
	parentescos = [], 
	errors = {}, 
	useAuth, 
	apiService, 
	Cargando, 
	setCargando, 
	idCabezaFamilia, 
	user, 
	token, 
	Mensaje,
    setValue, 
	getValues,
	append,
	remove,
	paises = [],
	barrios = [],
	municipiosdto = [],
    tiposDocumentos = []
}) {
    const [quienRemiteCasos, setQuienRemiteCasos] = React.useState([]);
	const [rutasActivadas, setRutasActivadas] = React.useState([]);
    const [tiposMedidasProteccion, setTiposMedidasProteccion] = React.useState([]);
    const [tipoInterpusoMedidaPenal, setTipoInterpusoMedidaPenal] = React.useState([]);
    const [tipoCodigoFucsia, setTipoCodigoFucsia] = React.useState([]);
    const [tiposConvivenciaAgresor, setTiposConvivenciaAgresor] = React.useState([]);
    const [tipoNroPresuntosAgresores, setTipoNroPresuntosAgresores] = React.useState([]);
    const [tipoPosicionesPoder, setTipoPosicionesPoder] = React.useState([]);
    const [tipoMedioUtilizado, setTipoMedioUtilizado] = React.useState([]);
    const [tipoRepeticionMetodo, setTipoRepeticionMetodo] = React.useState([]);
    const [tipoModalidadHecho, setTipoModalidadHecho] = React.useState([]);
    const [tipoActivacionRiesgo, setTipoActivacionRiesgo] = React.useState([]);
	const ObtenerDatosSelects = async () => {
		let url = `/ddhh/vulneraciones/obtenerdatosselectsvssexuales`;
		try {
			setCargando(true);
			const response = await apiService.get(url, token);
			const result = await response.data;
			setRutasActivadas(result.RutasActivadas || []);
			setQuienRemiteCasos(result.quienRemiteCasos || []);
			setTiposMedidasProteccion(result.tiposMedidasProteccion || []);
			setTipoInterpusoMedidaPenal(result.tipoInterpusoMedidaPenal || []);
			setTipoCodigoFucsia(result.tipoCodigoFucsia || []);
			setTiposConvivenciaAgresor(result.tiposConvivenciaAgresor || []);
			setTipoNroPresuntosAgresores(result.tipoNroPresuntosAgresores || []);
			setTipoPosicionesPoder(result.tipoPosicionesPoder || []);
			setTipoMedioUtilizado(result.tipoMedioUtilizado || []);
			setTipoRepeticionMetodo(result.tipoRepeticionMetodo || []);
			setTipoModalidadHecho(result.tipoModalidadHecho || []);
			setTipoActivacionRiesgo(result.tipoActivacionRiesgo || []);
            
		} catch (error) {
			console.error('Error fetching data:', error);
		} finally {
			setCargando(false);
		}
	}
    const rutaActivadaSeleccionada = watch ? watch('datosVulneracion.intIdtiporutaactivada') : getValues('datosVulneracion.intIdtiporutaactivada');
    const quienRemiteCasoSeleccionado = watch ? watch('datosVulneracion.intQuienremitecaso') : getValues('datosVulneracion.intQuienremitecaso');
    const medidaProteccionSeleccionada = watch ? watch('datosVulneracion.intMedidaproteccion') : getValues('datosVulneracion.intMedidaproteccion');
    const denunciaPenalSeleccionada = watch ? watch('datosVulneracion.intDenunciapenal') : getValues('datosVulneracion.intDenunciapenal');
    const codigoFucsiaSeleccionado = watch ? watch('datosVulneracion.intCodigofucsia') : getValues('datosVulneracion.intCodigofucsia');
    const parentescoVictimaSeleccionado = watch ? watch('datosVulneracion.intParentesvinculocovictima') : getValues('datosVulneracion.intParentesvinculocovictima');
    const convivenciaAgresorSeleccionada = watch ? watch('datosVulneracion.intConvivenciaagresor') : getValues('datosVulneracion.intConvivenciaagresor');
    const nroPresuntosAgresoresSeleccionado = watch ? watch('datosVulneracion.intNropresuntosagresores') : getValues('datosVulneracion.intNropresuntosagresores');
    const posicionPoderSeleccionada = watch ? watch('datosVulneracion.intPosicionpoder') : getValues('datosVulneracion.intPosicionpoder');
    const medioUtilizadoSeleccionado = watch ? watch('datosVulneracion.intMedioutilizado') : getValues('datosVulneracion.intMedioutilizado');
    const repeticionMetodoSeleccionada = watch ? watch('datosVulneracion.intRepeticionmetodo') : getValues('datosVulneracion.intRepeticionmetodo');
    const modalidadHechoSeleccionada = watch ? watch('datosVulneracion.intModalidadhecho') : getValues('datosVulneracion.intModalidadhecho');
    const activacionRiesgoSeleccionada = watch ? watch('datosVulneracion.intActivacionriesgo') : getValues('datosVulneracion.intActivacionriesgo');
	useEffect(() => {
		if (rutasActivadas.length === 0 && !rutaActivadaSeleccionada) {
			return;
		}
        const rutaActivadaSeleccionadaId =
            rutaActivadaSeleccionada && typeof rutaActivadaSeleccionada === 'object'
                ? (rutaActivadaSeleccionada.id ?? rutaActivadaSeleccionada.value ?? '')
                : rutaActivadaSeleccionada;
        setValue('datosVulneracion.intIdtiporutaactivada', rutaActivadaSeleccionadaId ? String(rutaActivadaSeleccionadaId) : '', { shouldValidate: true, shouldDirty: false });
	}, [rutaActivadaSeleccionada, rutasActivadas, setValue]);
    useEffect(() => {
        if (quienRemiteCasos.length === 0 || !quienRemiteCasoSeleccionado) {
            return;
        }
        setValue('datosVulneracion.intQuienremitecaso', String(quienRemiteCasoSeleccionado?.id ?? quienRemiteCasoSeleccionado?.value ?? quienRemiteCasoSeleccionado), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [quienRemiteCasos, quienRemiteCasoSeleccionado, setValue]);
    useEffect(() => {
        if (tiposMedidasProteccion.length === 0 || !medidaProteccionSeleccionada) {
            return;
        }
        setValue('datosVulneracion.intMedidaproteccion', String(medidaProteccionSeleccionada?.id ?? medidaProteccionSeleccionada?.value ?? medidaProteccionSeleccionada), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [tiposMedidasProteccion, medidaProteccionSeleccionada, setValue]);
    useEffect(() => {
        if (tipoInterpusoMedidaPenal.length === 0 || !denunciaPenalSeleccionada) {
            return;
        }
        setValue('datosVulneracion.intDenunciapenal', String(denunciaPenalSeleccionada?.id ?? denunciaPenalSeleccionada?.value ?? denunciaPenalSeleccionada), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [tipoInterpusoMedidaPenal, denunciaPenalSeleccionada, setValue]);
    useEffect(() => {
        if (tipoCodigoFucsia.length === 0 || !codigoFucsiaSeleccionado) {
            return;
        }
        setValue('datosVulneracion.intCodigofucsia', String(codigoFucsiaSeleccionado?.id ?? codigoFucsiaSeleccionado?.value ?? codigoFucsiaSeleccionado), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [tipoCodigoFucsia, codigoFucsiaSeleccionado, setValue]);
    useEffect(() => {
        if (parentescos.length === 0 || !parentescoVictimaSeleccionado) {
            return;
        }
        setValue('datosVulneracion.intParentesvinculocovictima', String(parentescoVictimaSeleccionado?.id ?? parentescoVictimaSeleccionado?.value ?? parentescoVictimaSeleccionado), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [parentescos, parentescoVictimaSeleccionado, setValue]);
    useEffect(() => {
        if (tiposConvivenciaAgresor.length === 0 || !convivenciaAgresorSeleccionada) {
            return;
        }
        setValue('datosVulneracion.intConvivenciaagresor', String(convivenciaAgresorSeleccionada?.id ?? convivenciaAgresorSeleccionada?.value ?? convivenciaAgresorSeleccionada), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [tiposConvivenciaAgresor, convivenciaAgresorSeleccionada, setValue]);
    useEffect(() => {
        if (tipoNroPresuntosAgresores.length === 0 || !nroPresuntosAgresoresSeleccionado) {
            return;
        }
        setValue('datosVulneracion.intNropresuntosagresores', String(nroPresuntosAgresoresSeleccionado?.id ?? nroPresuntosAgresoresSeleccionado?.value ?? nroPresuntosAgresoresSeleccionado), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [tipoNroPresuntosAgresores, nroPresuntosAgresoresSeleccionado, setValue]);
    useEffect(() => {
        if (tipoPosicionesPoder.length === 0 || !posicionPoderSeleccionada) {
            return;
        }
        setValue('datosVulneracion.intPosicionpoder', String(posicionPoderSeleccionada?.id ?? posicionPoderSeleccionada?.value ?? posicionPoderSeleccionada), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [tipoPosicionesPoder, posicionPoderSeleccionada, setValue]);
    useEffect(() => {
        if (tipoMedioUtilizado.length === 0 || !medioUtilizadoSeleccionado) {
            return;
        }
        setValue('datosVulneracion.intMedioutilizado', String(medioUtilizadoSeleccionado?.id ?? medioUtilizadoSeleccionado?.value ?? medioUtilizadoSeleccionado), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [tipoMedioUtilizado, medioUtilizadoSeleccionado, setValue]);
    useEffect(() => {
        if (tipoRepeticionMetodo.length === 0 || !repeticionMetodoSeleccionada) {
            return;
        }
        setValue('datosVulneracion.intRepeticionmetodo', String(repeticionMetodoSeleccionada?.id ?? repeticionMetodoSeleccionada?.value ?? repeticionMetodoSeleccionada), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [tipoRepeticionMetodo, repeticionMetodoSeleccionada, setValue]);
    useEffect(() => {
        if (tipoModalidadHecho.length === 0 || !modalidadHechoSeleccionada) {
            return;
        }
        setValue('datosVulneracion.intModalidadhecho', String(modalidadHechoSeleccionada?.id ?? modalidadHechoSeleccionada?.value ?? modalidadHechoSeleccionada), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [tipoModalidadHecho, modalidadHechoSeleccionada, setValue]);
    useEffect(() => {
        if (tipoActivacionRiesgo.length === 0 || !activacionRiesgoSeleccionada) {
            return;
        }
        setValue('datosVulneracion.intActivacionriesgo', String(activacionRiesgoSeleccionada?.id ?? activacionRiesgoSeleccionada?.value ?? activacionRiesgoSeleccionada), {
            shouldValidate: true,
            shouldDirty: false,
        });
    }, [tipoActivacionRiesgo, activacionRiesgoSeleccionada, setValue]);
	useEffect(() => {
		ObtenerDatosSelects();
	}, []);
	return (
		<div className="card">
			<div className="card-header">
				<div className="col-md-12">
					<h6 className="text-primary font-weight-bold mb-3">Datos de la Vulneracion Sexual</h6>
				</div>
			</div>
			<div className="card-body">
				<div className="row">
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.intQuienremitecaso">Quien remite el caso</label>
                            <select id="datosVulneracion.intQuienremitecaso" className="form-control" {...register('datosVulneracion.intQuienremitecaso' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {quienRemiteCasos.map((option, idx) => (
									<option key={option.id} value={option.id}>
										{option.str_nombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intQuienremitecaso && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdtiporutaactivada">Ruta activada</label>
                            <select id="datosVulneracion.intIdtiporutaactivada" className="form-control" {...register('datosVulneracion.intIdtiporutaactivada' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {rutasActivadas.map((option, idx) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intIdtiporutaactivada && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
                    <div className="col-md-3">
						<div className="form-group">
                                <label htmlFor="datosVulneracion.intMedidaproteccion">Medida de protecci&oacute;n o refugio requerida</label>
                                <select id="datosVulneracion.intMedidaproteccion" className="form-control" {...register('datosVulneracion.intMedidaproteccion' , { required: true })}>
                                    <option value="">Seleccione...</option>
                                    {tiposMedidasProteccion.map((option, idx) => (
                                        <option key={option.id} value={option.id}>
                                            {option.strNombre}
                                        </option>
                                    ))}
                                </select>
                                {errors.datosVulneracion?.intMedidaproteccion && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
						<div className="form-group">
                            <label htmlFor="datosVulneracion.intDenunciapenal">Interposici&oacute;n de denuncia penal</label>
                            <select id="datosVulneracion.intDenunciapenal" className="form-control" {...register('datosVulneracion.intDenunciapenal' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {tipoInterpusoMedidaPenal.map((option, idx) => (
                                    <option key={option.id} value={option.id}>
                                        {option.strNombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intDenunciapenal && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
				</div>
                <div className="row">
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.intCodigofucsia">¿Se activ&oacute; el c&oacute;digo fucsia?</label>
                            <select
                                id="datosVulneracion.intCodigofucsia"
                                className="form-control"
                                {...register('datosVulneracion.intCodigofucsia', { required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {tipoCodigoFucsia.map((option, idx) => (
                                    <option key={option.id} value={option.id}>
                                        {option.strNombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intCodigofucsia && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.intParentesvinculocovictima">Parentesco o v&iacute;nculo con la v&iacute;ctima (victimario)</label>
                            <select
                                id="datosVulneracion.intParentesvinculocovictima"
                                className="form-control"
                                {...register('datosVulneracion.intParentesvinculocovictima', { required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {parentescos.map((option, idx) => (
                                    <option key={option.id} value={option.id}>
                                        {option.parParentesco}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intParentesvinculocovictima && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.intConvivenciaagresor">Convivencia con el agresor</label>
                            <select
                                id="datosVulneracion.intConvivenciaagresor"
                                className="form-control"
                                {...register('datosVulneracion.intConvivenciaagresor', { required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {tiposConvivenciaAgresor.map((option, idx) => (
                                    <option key={option.id} value={option.id}>
                                        {option.strNombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intConvivenciaagresor && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.intNropresuntosagresores">N&uacute;mero de presuntos agresores</label>
                            <select
                                id="datosVulneracion.intNropresuntosagresores"
                                className="form-control"
                                {...register('datosVulneracion.intNropresuntosagresores', { required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {tipoNroPresuntosAgresores.map((option, idx) => (
                                    <option key={option.id} value={option.id}>
                                        {option.strNombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intNropresuntosagresores && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.intPosicionpoder">Posici&oacute;n de poder/asimetr&iacute;a</label>
                            <select
                                id="datosVulneracion.intPosicionpoder"
                                className="form-control"
                                {...register('datosVulneracion.intPosicionpoder', { required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {tipoPosicionesPoder.map((option, idx) => (
                                    <option key={option.id} value={option.id}>
                                        {option.strNombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intPosicionpoder && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.intMedioutilizado">Medio o instrumento utilizado</label>
                            <select
                                id="datosVulneracion.intMedioutilizado"
                                className="form-control"
                                {...register('datosVulneracion.intMedioutilizado', { required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {tipoMedioUtilizado.map((option, idx) => (
                                    <option key={option.id} value={option.id}>
                                        {option.strNombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intMedioutilizado && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.strOtromedio">Si la respuesta anterior fue otro, ¿cu&aacute;l?</label>
                            <input
                                type="text"
                                id="datosVulneracion.strOtromedio"
                                className="form-control"
                                {...register('datosVulneracion.strOtromedio', { required: true })}
                            />
                            {errors.datosVulneracion?.strOtromedio && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.intRepeticionmetodo">Repetici&oacute;n del hecho</label>
                            <select
                                id="datosVulneracion.intRepeticionmetodo"
                                className="form-control"
                                {...register('datosVulneracion.intRepeticionmetodo', { required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {tipoRepeticionMetodo.map((option, idx) => (
                                    <option key={option.id} value={option.id}>
                                        {option.strNombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intRepeticionmetodo && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <div className="form-group">
                                <label htmlFor="datosVulneracion.intModalidadhecho">Modalidad/&aacute;mbito del hecho</label>
                                <select
                                    id="datosVulneracion.intModalidadhecho"
                                    className="form-control"
                                    {...register('datosVulneracion.intModalidadhecho', { required: true })}
                                >
                                    <option value="">Seleccione...</option>
                                    {tipoModalidadHecho.map((option, idx) => (
                                        <option key={option.id} value={option.id}>
                                            {option.strNombre}
                                        </option>
                                    ))}
                                </select>
                                {errors.datosVulneracion?.intModalidadhecho && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.intActivacionriesgo">Activaci&oacute;n de criterio de riesgo</label>
                            <select
                                id="datosVulneracion.intActivacionriesgo"
                                className="form-control"
                                {...register('datosVulneracion.intActivacionriesgo', { required: true })}
                            >
                                <option value="">Seleccione...</option>
                                {tipoActivacionRiesgo.map((option, idx) => (
                                    <option key={option.id} value={option.id}>
                                        {option.strNombre}
                                    </option>
                                ))}
                            </select>
                            {errors.datosVulneracion?.intActivacionriesgo && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label htmlFor="datosVulneracion.strDescripcionsituacion">Descripci&oacute;n de la situaci&oacute;n</label>
                            <textarea
                                id="datosVulneracion.strDescripcionsituacion"
                                className="form-control"
                                {...register('datosVulneracion.strDescripcionsituacion', { required: true })}
                            />
                            {errors.datosVulneracion?.strDescripcionsituacion && <span className="text-danger">Este campo es obligatorio</span>}
                        </div>
                    </div>
                </div>
				<hr />
                <RedesContacto
                    register={register}
                    getValues={getValues}
                    watch={watch}
                    append={append}
                    remove={remove}
                    errors={errors}
                    paises={paises}
                    barrios={barrios}
                    municipiosdto={municipiosdto}
                    parentescos={parentescos}
                    tiposDocumentos={tiposDocumentos}
                />
                <hr />

				<input type="hidden" {...register('datosVulneracion.intVulneracionderechosid', { valueAsNumber: true })} />
			</div>
		</div>
	);
}
